// extracted by mini-css-extract-plugin
export default {"bold":"PrivacyPolicyDisclaimer_bold__BBtEF"};